import {
    AfterViewInit,
    Component,
    EventEmitter,
    HostListener,
    Inject,
    Input,
    Optional,
    Output,
    QueryList,
    ViewChildren,
    ViewEncapsulation
} from '@angular/core';
import { CKEditorComponent } from '@ckeditor/ckeditor5-angular';
import { BalloonEditor } from '@ckeditor/ckeditor5-editor-balloon';
import _ from 'lodash';
import sanitizeHtml from 'sanitize-html';
import { AlertService } from 'src/app/services/alert.service';
import { ViewComponent } from 'src/app/shared/pages/view/view.component';
import { ActivatedRoute, Router } from '@angular/router';
import { LoaderService } from 'src/app/services/loader.service';
import { AuthService } from 'src/app/services/auth.service';
import { ConfirmDialogComponent } from 'src/app/shared/components/dialog/confirm-dialog/confirm-dialog.component';
import { MAT_DIALOG_DATA as MAT_DIALOG_DATA, MatDialog as MatDialog, MatDialogRef as MatDialogRef } from '@angular/material/dialog';
import { ITranslatedText, ProductionTexts } from 'src/app/models/production-texts.model';
import { defaultTexts, languages } from 'src/app/LIVECO.define';
import { TranslateService } from '@ngx-translate/core';
import { SelectDialog, SelectDialogOptions } from 'src/app/shared/components/dialog/select-dialog/select-dialog.component';
import { InputDialogOptions, InputDialog } from 'src/app/shared/components/dialog/input-dialog/input-dialog.component';
import { ProductionTextsService } from 'src/app/services/production-texts.service';
import { ServiceSelectDialog, ServiceSelectDialogOptions } from 'src/app/shared/components/dialog/service-select-dialog/service-select-dialog.component';
import { ProjectService } from 'src/app/services/project.service';




@Component({
    selector: 'app-production-texts',
    templateUrl: './production-texts.component.html',
    styleUrls: ['./production-texts.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class ProductionTextsComponent extends ViewComponent implements AfterViewInit {

    // public Editor = BalloonEditor;
    // @ViewChildren('editor') ckeditors: QueryList<CKEditorComponent>;
    // ckConfig = {
    //     licenseKey: 'GPL',
    // };

    // VIEW
    get display() {
        return this.s_productionTexts.display;
    }
    set display(value: 'legal' | 'marketing' | 'tvn') {
        this.s_productionTexts.display = value;
    }
    @Input() readOnly: boolean = this.data?.readOnly || false;

    // PROOFREADING
    // @Input() proofreadingID: string | undefined;

    // PROJECT
    @Input() project: { ID: string, identifier: string; } | undefined;
    
    get _project() {
        return this.project || this.data?.project;
    }

     // TEXTS
    @Input() textID: string | undefined;
    get productionTexts() {
        return this.s_productionTexts.current;
    }
    @Input() set productionTexts(value: ProductionTexts | undefined) {
        this.s_productionTexts.current = value;
        this.productionTextsChange.emit(this.s_productionTexts.current);
    }
    @Output() productionTextsChange = new EventEmitter<ProductionTexts | undefined>();

    @Input() type: 'intern' | 'extern' | 'modal' = 'modal';

    cachedCurrent: ProductionTexts | undefined;

    constructor(
        protected route: ActivatedRoute,
        protected router: Router,
        protected s_alert: AlertService,
        protected s_loader: LoaderService,
        protected s_auth: AuthService,
        protected dialog: MatDialog,
        protected s_productionTexts: ProductionTextsService,
        protected s_projects: ProjectService,
        
        @Optional() public dialogRef: MatDialogRef<ProductionTextsComponent>,
        @Optional() @Inject(MAT_DIALOG_DATA) public data: Partial<ProductionTexts & { readOnly: boolean, langue_ordre?: string[] }>,
    ) {
        super(route, router, s_alert, s_loader, s_auth);
    }

    ngOnInit(): void {
        this.s_productionTexts.display = 'legal';
    }
 
    async ngAfterViewInit() {
        if (this.textID) {
            await this.s_productionTexts.getCurrent(this.textID);
        } else if (this._project) {
            const texts = await this.s_productionTexts.find({ 'project.ID': this._project.ID, $limit: 1 });
            if (texts[0]) this.s_productionTexts.emitCurrent(texts[0]);
        }

        this.subscription.add(this.s_productionTexts.current$.subscribe((val) => {
            if (this.productionTexts) {
                this.cachedCurrent = this.s_productionTexts.cachedCurrent = new ProductionTexts(_.cloneDeep(this.productionTexts));
            }
        }));
    }

    // canDeactivate(): boolean {
    //     console.log('CAN DEACT', !this.cachedCurrent || this.productionTexts?.countDifference(this.cachedCurrent) === 0);
    //     // return !this.cachedCurrent || this.productionTexts?.countDifference(this.cachedCurrent) === 0;
    // }

    // @HostListener('window:beforeunload', ['$event'])
    // unloadNotification($event: any): void {
    //     if (!this.canDeactivate()) {
    //         $event.preventDefault();
    //         $event.returnValue = '';
    //     }
    // }

    openAddTextDialog() {
        this.dialog.open(ConfirmDialogComponent, {
            panelClass: 'dialog',
            data: {
                title: 'ARE_YOU_SURE',
                text: 'PRODUCTION_TEXTS.ARE_YOU_SURE_ADD',
                valid: 'OK',
                noConfirm: false
            },
            width: '450px'
        }).afterClosed().subscribe((response: any) => {
            if (response) {
                this.addProductionTexts();
            }
        });
    }

    async addProductionTexts() {
        this.productionTexts = this.s_productionTexts.addTexts({ project: this.project || undefined, });
        await this.persist();
    }

    async persist() {
        try {
            await this.s_productionTexts.persistCurrent();
            this.s_alert.success('PRODUCTION_TEXTS.SAVED');            
        } catch (err) {
            this.s_alert.error('PRODUCTION_TEXTS.ERROR_SAVING');
            throw err;
        }
    }

    openRemoveTextDialog(field: ITranslatedText) {
        this.dialog.open(ConfirmDialogComponent, {
            panelClass: 'dialog',
            data: {
                title: 'ARE_YOU_SURE',
                text: 'PRODUCTION_TEXTS.ARE_YOU_SURE_REMOVE',
                valid: 'OK',
                noConfirm: false
            },
            width: '450px'
        }).afterClosed().subscribe((response: any) => {
            if (response) {
                this.removeProductionText(field);
            }
        });
    }

    async removeProductionText(field: ITranslatedText) {
        this.productionTexts?.removeField(field.label);
        this.s_alert.success('PRODUCTION_TEXTS.REMOVED');
    }


    async addLanguage() {
        const options: SelectDialogOptions = {
            title: 'SELECT_LANGUAGE',
            valid: 'OK',
            data: languages,
            defaultValue: this.productionTexts?.current.langs || ['fr'],
            label: 'LANGUAGES',
            multiple: true,
            order: true,
        };
        this.dialog
            .open(SelectDialog, {
                panelClass: 'dialog',
                data: options,
                disableClose: true,
                // width: '450px',
                // height: '450px'
            })
            .afterClosed()
            .subscribe((response: any) => {
                const { data } = response;
                if (data) {
                    this.productionTexts?.setLangs(data);
                }
            });
    }


    async addField() {
        const options: InputDialogOptions = {
            title: 'PRODUCTION_TEXTS.ADD_FIELD',
            valid: 'OK',
            label: 'PRODUCTION_TEXTS.FIELD_NAME',
            defaultValue: '',
            placeholder: 'PRODUCTION_TEXTS.FIELD_PLACEHOLDER',
        };
        this.dialog
            .open(InputDialog, {
                panelClass: 'dialog',
                data: options,
                disableClose: true,
                width: '450px'
            })
            .afterClosed()
            .subscribe((response: any) => {
                const { data } = response;
                if (data) {
                    this.productionTexts?.addField(data, this.display as 'legal' | 'marketing');
                }
            });
    }

    setLabel($event: Event, field: ITranslatedText) {
        field.label = ($event.target as any).innerText as any;

        console.log(this.productionTexts?.texts);
    }

    //#region  CHECK DIFF

    // COMAPARE CURRENT WITH A CACHED COPY AT START OF COMPONENT
    countUpdated() {
        if (this.cachedCurrent && this.productionTexts) {
            return this.productionTexts.countDifference(this.cachedCurrent);
        } return 0;
    }

    // COMPARE CURRENT AND LAST, FROM LAST RELECTURE
    checkVersionChanged(field: ITranslatedText, lang: string) {
        return this.productionTexts?.checkLastVersionChange(field, lang);
    }

    countVersionChanged(lang?: string) {
        return this.productionTexts?.countLastVersionChange(lang) || 0;
    }

    //#endregion
    clipboardCopy(text: string) {
        navigator.clipboard.writeText(sanitizeHtml(text, { allowedTags: [] })).then(() => {
            this.s_alert.success('TEXT.COPIED');
        });
    }

    openPrefilModal() {
        const options: ServiceSelectDialogOptions = {
            title: 'PRODUCTION_TEXTS.PREFILL',
            label: 'PRODUCTION_TEXTS.PREFILL_SELECT_REF',
            text: 'PRODUCTION_TEXTS.PREFILL_SELECT_REF_TEXT',
            placeholder: 'PRODUCTION_TEXTS.PREFILL_SELECT_REF_PLACEHOLDER',
            service: this.s_productionTexts,
            query: { $select: ['project.identifier'], $sort: { createdAt: -1 } },
            display(v) {
                return v?.project?.identifier;
            },
            multiple: false,
        };

        this.dialog
            .open(ServiceSelectDialog, {
                data: options,
                width: '450px'
            })
            .afterClosed()
            .subscribe(async (response: any) => {
                const productionTexts = response?.data;
                if (productionTexts) {
                    const prefiller = await this.s_productionTexts.get(productionTexts._id);
                    this.s_productionTexts.prefill(_.pick(prefiller, ['current']));
                }
            });
    }

    isDefaultField(label: string) {
        return !!defaultTexts.find(t => t.label === label);
    }


    public onError(event: any): void {
        console.error('Erreur CKEditor détectée :', event);
      }
      
}
